export { default as AgreementsTemplate } from "./AgreementsTemplate";
